import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { useVolume } from '@tmsw/powerups.audio.hooks.use-volume';
import { usePlayer } from '@tmsw/powerups.audio.hooks.use-player';
// @ts-ignore
import testToneFile from './click-converted.mp3';
import './volume-controls.css';

export type VolumeControlsProps = {
  item?: any;
  options?: any;
};

export function VolumeControls({ item, options }: VolumeControlsProps) {
  const { __t } = useTranslation('SETTINGS_PANEL');
  const { volume, updateVolume } = useVolume();

  const label = item
    ? options.translations[item.headingLocaleKey]
    : __t('volumeSetting', 'SETTINGS_PANEL');

  const player = usePlayer({
    name: 'volumeTestTone',
    url: testToneFile,
  });

  return (
    <div className="volume-settings-container">
      <span className="volume-setting-container-label">{label}</span>
      <span id="VolumeSlider" className="volume-slider">
        <button
          type="button"
          className="volume-down"
          aria-label={__t('volumeDown')}
          onClick={() => {
            updateVolume(volume - 10);
            player.stop().start();
          }}
        />
        <input
          className="volume-range"
          type="range"
          min={0}
          max={100}
          step={10}
          aria-label={__t('volumeControlSlider') || __t('volumeSetting')}
          aria-valuenow={volume}
          value={volume}
          onChange={(evt) => {
            updateVolume(parseInt(evt.target.value, 10));
            player.stop().start();
          }}
          style={{
            backgroundSize: `${volume}% 100%`,
          }}
        />
        <button
          type="button"
          className="volume-up"
          aria-label={__t('volumeUp')}
          onClick={() => {
            updateVolume(volume + 10);
            player.stop().start();
          }}
        />
      </span>
    </div>
  );
}
